export const FETCH_SIMPLE_WISHLIST = 'wishlist/FETCH';
export const FETCH_SIMPLE_WISHLIST_SUCCESS = `${FETCH_SIMPLE_WISHLIST}_SUCCESS`;
export const FETCH_SIMPLE_WISHLIST_FAIL = `${FETCH_SIMPLE_WISHLIST}_FAIL`;

export const ADD_TO_WISHLIST = 'wishlist/ADD';
export const ADD_TO_WISHLIST_SUCCESS = `${ADD_TO_WISHLIST}_SUCCESS`;
export const REMOVE_FROM_WISHLIST = 'wishlist/REMOVE';
export const REMOVE_FROM_WISHLIST_SUCCESS = `${REMOVE_FROM_WISHLIST}_SUCCESS`;

const initialState = { isLoading: false, products: [] };

/* eslint-disable */
const SimpleWishlistReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_SIMPLE_WISHLIST:
      return { ...state, isLoading: true };
    case FETCH_SIMPLE_WISHLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        products: action.payload.data.map(({ skuId }) => skuId),
      };
    case FETCH_SIMPLE_WISHLIST_FAIL:
      return { ...state, isLoading: false };
    case ADD_TO_WISHLIST_SUCCESS:
      return {
        ...state,
        products: [
          ...state.products,
          ...action.payload?.products,
        ],
      };
    case REMOVE_FROM_WISHLIST_SUCCESS:
      return {
        ...state,
        products: state.products.filter((sku) => sku !== action.payload.sku),
      };
    default:
      return state;
  }
};

export default SimpleWishlistReducer;
